import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './plugins/router';
import store from './store/index';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';
import VueGtag from 'vue-gtag';
import VueQrcodeReader from 'vue-qrcode-reader';
import VueQrcode from '@chenfengyuan/vue-qrcode';

import { i18n } from '@/plugins/i18n';
import VueYoutube from 'vue-youtube';

import VModal from 'vue-js-modal';

import { globalMixin } from '@/mixins/globalMixin';

store.dispatch('initInformation').then(() => {
  if (store.state.eventMaster !== null) {
    const { google_analytics_id, event_name } = store.state.eventMaster.m_event;
    document.title = event_name;
    if (typeof google_analytics_id !== 'undefined') {
      Vue.use(VueGtag, {
        config: {
          id: google_analytics_id
        }
      });
    }
  }
});

Vue.config.productionTip = false;
Vue.use(VueYoutube);

Vue.use(Vuelidate);

Vue.use(vuetify);

Vue.use(Notifications);
Vue.use(VueQrcodeReader);
Vue.component(VueQrcode.name, VueQrcode);

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.mixin(globalMixin);

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
